<template>
	<v-container>
		<br />
		<v-layout class="mt-3">
			<v-flex center xs12>
				<v-img
					contain
					aspect-ratio="3.5"
					class="d-none d-lg-flex"
					:src="require('../assets/Sharpsmart-LogoMedium.png')"
				></v-img>
			</v-flex>
		</v-layout>
		<v-layout class="grey lighten-3 pa-2 mt-8">
			<v-flex xs12>
				<h1 v-if="formType === 'other'" class="font-weight-medium text-center">
					Other Waste Enquiry
				</h1>
				<h1
					v-if="formType === 'regular'"
					class="font-weight-medium text-center"
				>
					Regular Waste Service Request
				</h1>
				<h1
					v-if="formType === 'confidential'"
					class="font-weight-medium text-center"
				>
					Confidential Service Request
				</h1>
				<span v-if="formType === 'regular'">
					Please ensure you have sought appropriate authorisation for disposal
					of these items from the Asset Manager before booking a request.
					Additionally, please consider if these item could be listed on Warp-it
					if it is reusable for another department.
				</span>

				<p v-if="formType === 'regular'" class="text-center">
					<a href="http://warp-it.co.uk/royalfree"
						>www.warp-it.co.uk/royalfree</a
					>
				</p>
				<p v-if="formType === 'regular'" class="text-center">
					<a href="https://www.warp-it.co.uk/company/northmid"
						>www.warp-it.co.uk/company/northmid</a
					>
				</p>
			</v-flex>
		</v-layout>
		<v-layout class="grey lighten-3 pa-2 wastedesc mt-4">
			<v-flex>
				<span>
					<h3 class="title text-center">Location Information Section</h3>
					<br />
				</span>
				<span>
					<h3 class="text">
						Please accurately fill out the location of the waste by choosing
						from the following drop down options.
					</h3>
				</span>
			</v-flex>
		</v-layout>
		<!-- ----------------- Modal -------------------- -->
		<v-layout row justify-center>
			<v-dialog v-model="formDialog" persistent max-width="350">
				<!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>-->
				<v-card>
					<v-card-title class="headline">Service Type</v-card-title>
					<v-card-text>Please choose your service type:</v-card-text>

					<div class="px-2 center">
						<v-btn color="info" text @click="setForm('regular')"
							>Dump The Junk</v-btn
						>
					</div>

					<div class="pa-2 center">
						<v-btn color="info" text @click="setForm('confidential')"
							>Confidential Waste</v-btn
						>
					</div>

					<div class="pa-2 center">
						<v-btn color="info" text @click="setForm('other')"
							>Other Waste Enquiry</v-btn
						>
					</div>
				</v-card>
			</v-dialog>
		</v-layout>
		<!-- ----------------- End Modal -------------------- -->
		<v-layout
			v-if="formType === 'confidential'"
			class="mt-8"
			red--text
			row
			justify-center
			>Confidential Waste Service</v-layout
		>
		<v-form lazy-validation ref="form2" class="mt-10">
			<v-layout class="pa-2">
				<v-flex>
					<v-layout row>
						<v-flex ma-2>
							<p>Site *</p>
							<v-select
								class="my-2"
								:items="sitesDropdown"
								label="Select Site"
								v-model="form.sites"
								@change="setModal"
								outlined
								:rules="Required"
								required
							>
								<template v-slot:item="{ item }">
									{{ item.site }} {{ item.hospital ? "Hospital" : "" }}
								</template>
								<template v-slot:selection="{ item }">
									{{ item.site }} {{ item.hospital ? "Hospital" : "" }}
								</template>
							</v-select>
						</v-flex>
						<v-flex v-if="formType === 'regular'" ma-2>
							<p>Building</p>
							<v-text-field
								v-model="form.building"
								placeholder
								outlined
							></v-text-field>
						</v-flex>
						<v-flex
							v-if="formType === 'confidential' || formType === 'other'"
							ma-2
						>
							<p>Department *</p>
							<v-text-field
								v-model="form.department"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<p v-if="formType === 'regular' || formType === 'other'">
								Floor *
							</p>
							<p v-if="formType === 'confidential'">Floor Number *</p>
							<v-text-field
								v-model="form.floor"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
						<v-flex ma-2 v-if="formType !== 'other'">
							<p>Room Number *</p>
							<v-text-field
								v-model="form.roomNum"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2 v-if="formType !== 'other'">
							<p>Location Description*</p>
							<v-text-field
								v-model="form.locDesc"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
						<v-flex v-if="formType === 'regular' || formType === 'other'" ma-2>
							<p>Department Name *</p>
							<v-text-field
								v-model="form.deptLocation"
								placeholder
								outlined
								:rules="Required"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<p v-if="formType === 'regular'">Asset Manager *</p>
							<p v-if="formType === 'confidential'">Dept. Manager *</p>
							<v-text-field
								v-if="formType !== 'other'"
								v-model="form.asstManager"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
						<v-flex ma-2 v-if="formType !== 'other'">
							<p>Budget Code/Invoicing Details</p>
							<v-text-field
								v-model="form.budgetCode"
								placeholder
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout class="grey lighten-3 pa-2 mt-4">
						<v-flex>
							<span>
								<h3 class="title text-center">Contact Information Section</h3>
								<br />
							</span>
							<span>
								<h3 class="text">
									Please provide your contact details and an alternative contact
									in this section of the form.
								</h3>
							</span>
						</v-flex>
					</v-layout>
					<v-layout
						v-if="formType === 'confidential'"
						class="mt-8"
						red--text
						row
						justify-center
						>Confidential Waste Service</v-layout
					>

					<v-layout row class="mt-3">
						<v-flex ma-2>
							<p>Contact Name *</p>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<v-text-field
								label="First Name"
								v-model="form.fName"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
						<v-flex ma-2>
							<v-text-field
								label="Last Name"
								v-model="form.lName"
								placeholder
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<p>Contact Phone *</p>
							<v-text-field
								placeholder
								label="Contact Phone"
								v-model="form.phone"
								outlined
								:rules="Required"
								required
							></v-text-field>
						</v-flex>
						<v-flex ma-2>
							<p>Contact Email *</p>
							<v-text-field
								placeholder
								label="Please enter your valid email address at NHS"
								v-model="form.email"
								outlined
								:rules="emailRules"
								required
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<p>Alternate Contact Name</p>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex ma-2>
							<v-text-field
								label="First Name"
								v-model="form.altFName"
								outlined
							></v-text-field>
						</v-flex>
						<v-flex ma-2>
							<v-text-field
								label="Last Name"
								v-model="form.altLName"
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout row>
						<v-flex ma-2>
							<p>Alternate Contact Phone</p>
							<v-text-field
								label="Contact Phone"
								v-model="form.altPhone"
								outlined
							></v-text-field>
						</v-flex>
						<v-flex ma-2>
							<p>Alternate Contact Email</p>
							<v-text-field
								label="Please enter your valid email address at NHS"
								v-model="form.altEmail"
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>

					<v-layout
						v-if="formType === 'regular' || formType === 'other'"
						class="grey lighten-3 c mt-4"
					>
						<v-flex>
							<span>
								<h3 class="title text-center">Waste Detail</h3>
								<br />
							</span>
							<span>
								<h3 class="text">
									Please supply as much information about the waste item(s) as
									possible. Each item for disposal will need to be itemised.
									<p>
										Pictures can also be uploaded here. These will help us to
										plan the manpower for the removal of the waste.
									</p>
								</h3>
							</span>
						</v-flex>
					</v-layout>

					<v-layout
						v-if="formType === 'confidential'"
						class="grey lighten-3 c mt-4"
					>
						<v-flex>
							<span>
								<h3 class="title text-center">Confidential Service Detail</h3>
								<br />
							</span>
							<span>
								<h3 class="text">
									Please note that each bag must not exceed 25kg in weight or be
									overfilled
									<br />Any confidential waste must be securely sealed.
								</h3>
							</span>
							<br />
						</v-flex>
					</v-layout>

					<v-layout
						v-if="formType === 'confidential'"
						class="mt-8"
						red--text
						row
						justify-center
						>Confidential Waste Service</v-layout
					>

					<v-layout v-if="formType === 'regular'" row class="pa-2 ma-2">
						<p>Waste Types *</p>

						<v-flex
							v-for="(waste, index) in wasteType"
							:key="index"
							class="px-2"
							xs12
						>
							<v-row align="center">
								<v-checkbox
									:label="waste.label"
									:value="waste.value"
									v-model="form.selected"
									:hide-details="index !== wasteType.length - 1"
									@change="checkEnabled(waste.value)"
									multiple
								></v-checkbox>
								<v-text-field
									v-if="waste.label === 'Other'"
									class="mx-4"
									v-model="OtherText"
									:disabled="!enabled"
								></v-text-field>
							</v-row>
						</v-flex>
					</v-layout>

					<v-layout v-else-if="formType === 'other'" row class="pa-2 ma-2">
						<p>Waste Types *</p>
						<v-flex
							v-for="(waste, index) in otherWaste"
							:key="index"
							class="px-2"
							xs12
						>
							<v-row align="center">
								<v-checkbox
									:label="waste.label"
									:value="waste.value"
									v-model="form.selected"
									:hide-details="index !== otherWaste.length - 1"
									@change="checkEnabled(waste.value)"
									multiple
								></v-checkbox>
								<v-text-field
									v-if="waste.label === 'Other'"
									class="mx-4"
									v-model="OtherText"
									:disabled="!enabled"
								></v-text-field>
							</v-row>
						</v-flex>
					</v-layout>

					<!-- Confidential service switch select -->
					<p v-if="formType === 'confidential'">Type *</p>
					<v-layout v-if="formType === 'confidential'" row class="px-2 mx-2">
						<v-flex xs12 md2>
							<v-switch
								v-model="form.confWasteConsole"
								:label="`Console: `"
							></v-switch>
						</v-flex>
						<v-flex xs12 md3 mx-2 v-if="form.confWasteConsole === true">
							<v-text-field
								label="Console Quantity"
								v-model="form.consoleQty"
								:rules="Required"
								outlined
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3 mx-2 v-if="form.confWasteConsole === true">
							<v-text-field
								label="Console ID (i.e., 3,6,7)"
								v-model="form.consoleList"
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout v-if="formType === 'confidential'" row class="px-2 mx-2">
						<v-flex xs12 md2>
							<v-switch v-model="form.confWasteBin" :label="`Bin: `"></v-switch>
						</v-flex>
						<v-flex xs12 md3 mx-2 v-if="form.confWasteBin === true">
							<v-text-field
								label="Bin Quantity"
								v-model="form.binQty"
								:rules="Required"
								outlined
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3 mx-2 v-if="form.confWasteBin === true">
							<v-text-field
								label="Bin ID (i.e., 3,6,7)"
								v-model="form.binList"
								:rules="Required"
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout v-if="formType === 'confidential'" row class="px-2 mx-2">
						<v-flex xs12 md2>
							<v-switch v-model="form.confWasteBag" :label="`Bag:`"></v-switch>
						</v-flex>
						<v-flex xs12 md3 mx-2 v-if="form.confWasteBag === true">
							<v-text-field
								label="Bag Quantity"
								v-model="form.bagQty"
								:rules="Required"
								outlined
							></v-text-field>
						</v-flex>
					</v-layout>

					<!-- Add a div or wrapper of some sort for this -->

					<p v-if="formType === 'regular' || formType === 'other'">
						Request Detail *
					</p>
					<v-layout v-if="formType === 'regular' || formType === 'other'">
						<v-col cols="12" md="12">
							<v-textarea
								outlined
								name="input-7-4"
								auto-grow
								v-model="form.requestDetails"
								:rules="Required"
								value
							></v-textarea>
						</v-col>
					</v-layout>
					<p v-if="formType === 'confidential'">Request Detail</p>
					<v-layout v-if="formType === 'confidential'">
						<v-col cols="12" md="12">
							<v-textarea
								outlined
								name="input-7-4"
								auto-grow
								v-model="form.requestDetails"
								value
							></v-textarea>
						</v-col>
					</v-layout>
					<p v-if="formType === 'regular'">Upload a picture</p>
					<v-layout v-if="formType === 'regular'">
						<v-flex md5>
							<v-file-input
								chips
								outlined
								multiple
								show-size
								counter
								accept="image/*"
								label="Choose File"
								class="file-select1"
								v-model="pics"
							></v-file-input>
						</v-flex>
					</v-layout>
					<br />

					<p v-if="formType === 'regular'">
						Prior to completing this form, did you attempt to list this item
						using the 'Warp It' system? *
					</p>

					<v-radio-group
						v-if="formType === 'regular'"
						v-model="form.warpIt"
						:rules="Required"
					>
						<v-radio label="YES" value="YES"></v-radio>
						<v-radio label="NO" value="NO"></v-radio>
						<v-radio label="Not Applicable" value="NA"></v-radio>
					</v-radio-group>
					<br />
					<p v-if="formType === 'regular' || formType === 'other'">
						I can confirm that all items have been checked for confidential
						material, and this has been removed and disposed appropriately.*
					</p>
					<p v-if="formType === 'confidential'">
						I can confirm that all detail is accurate on this form.*
					</p>

					<v-checkbox
						class="checkArray"
						v-model="form.confirm"
						label="YES"
						value="YES"
						:rules="Required"
					></v-checkbox>

					<div class="center">
						<v-btn
							color="#00807a"
							dark
							class="mx-0 mt-3"
							@click="submitForm()"
							:loading="loading"
							>Submit Request</v-btn
						>
					</div>
					<v-alert v-if="submitError" type="error" outlined dense>
						{{ submitError }}
					</v-alert>
				</v-flex>
			</v-layout>
		</v-form>
		<v-snackbar
			v-model="userFeedback"
			:multi-line="multiLine"
			:timeout="timeout"
			color="#00807a"
			absolute
			class="text-center"
		>
			Your request number is:
			<br />
			{{ this.requestId }}
			<br />
			<template v-if="emailSent">
				A confirmation has been sent to your mailbox.
			</template>
			<template v-else>
				We could not send a confirmation email, but your request has been
				received.
			</template>
			<v-btn color="white" text @click="userFeedback = false">
				<v-icon>{{ svgPath }}</v-icon>
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import axios from "axios";
import { mdiClose } from "@mdi/js";
import { sitesDropdown } from "@/constants/sitesDropdown";

const SUBMIT_REQUEST_URL =
	"https://us-central1-ukforms-764a8.cloudfunctions.net/submitRequest";
// Keep in line with the limits in functions/submitRequest.js
const MAX_PICS = 10;
const MAX_PIC_BYTES = 10 * 1024 * 1024;
const MAX_TOTAL_PIC_BYTES = 25 * 1024 * 1024;

export default {
	data() {
		return {
			sitesDropdown,
			formType: "regular",
			formDialog: false,
			// form: {
			// 	formType: "",
			// 	sites: "",
			// 	building: "test",
			// 	department: "test",
			// 	floor: "test",
			// 	roomNum: "test",
			// 	locDesc: "test",
			// 	deptLocation: "test",
			// 	asstManager: "test",
			// 	budgetCode: "test",
			// 	fName: "test",
			// 	lName: "test",
			// 	altFName: "",
			// 	altLName: "",
			// 	phone: "test",
			// 	altPhone: "",
			// 	email: "test@dantest.com",
			// 	altEmail: "",
			// 	selected: [],
			// 	containerNumber: "",
			// 	confidentialWasteType: "",
			// 	qty: "",
			// 	list: "",
			// 	requestDetails: "test",
			// 	picArray: [],
			// 	warpIt: "YES",
			// 	confirm: "YES",
			// 	status: "Open",
			// 	closeTech: "",
			// 	confWasteConsole: false,
			// 	consoleQty: "",
			// 	consoleList: "",
			// 	confWasteBin: false,
			// 	binQty: "",
			// 	binList: "",
			// 	confWasteBag: false,
			// 	bagQty: "",
			// },
			form: {
				formType: "",
				sites: "",
				building: "",
				department: "",
				floor: "",
				roomNum: "",
				locDesc: "",
				deptLocation: "",
				asstManager: "",
				budgetCode: "",
				fName: "",
				lName: "",
				altFName: "",
				altLName: "",
				phone: "",
				altPhone: "",
				email: "",
				altEmail: "",
				selected: [],
				containerNumber: "",
				confidentialWasteType: "",
				qty: "",
				list: "",
				requestDetails: "",
				picArray: [],
				warpIt: "",
				confirm: "",
				status: "Open",
				closeTech: "",
				confWasteConsole: false,
				consoleQty: "",
				consoleList: "",
				confWasteBin: false,
				binQty: "",
				binList: "",
				confWasteBag: false,
				bagQty: "",
			},
			pics: [],
			requestId: "",
			wasteType: [
				{ label: "Furniture", checked: false, value: "Furniture" },
				{
					label: "Waste Electricals",
					checked: false,
					value: "Waste Electricals",
				},
				{ label: "Batteries", checked: false, value: "Batteries" },
				{ label: "Bulk Disposal", checked: false, value: "Bulk Disposal" },
				{ label: "Other", checked: false, value: "Other" },
			],
			otherWaste: [
				{
					label: "Bed/Trolley Disposal",
					checked: false,
					value: "Bed/Trolley Disposal",
				},
				{ label: "Chemical Waste", checked: false, value: "Chemical Waste" },
				{ label: "Clinical Waste", checked: false, value: "Clinical Waste" },
				{
					label: "Department Audit",
					checked: false,
					value: "Department Audit",
				},
				{
					label: "Department Training",
					checked: false,
					value: "Department Training",
				},
				{
					label: "Feminine Hygiene",
					checked: false,
					value: "Feminine Hygiene",
				},
				{ label: "Food Waste", checked: false, value: "Food Waste" },
				{ label: "General Waste", checked: false, value: "General Waste" },
				{ label: "Hazardous Waste", checked: false, value: "Hazardous Waste" },
				{ label: "IT Disposal", checked: false, value: "IT Disposal" },
				{ label: "Linen", checked: false, value: "Linen" },
				{
					label: "Mattress Disposal",
					checked: false,
					value: "Mattress Disposal",
				},
				{ label: "Pallets", checked: false, value: "Pallets" },
				{
					label: "Pharmaceutical Waste",
					checked: false,
					value: "Pharmaceutical Waste",
				},
				{ label: "Recycling", checked: false, value: "Recycling" },
				{ label: "Sharps", checked: false, value: "Sharps" },
				{
					label: "Supply Stock/Equipment",
					checked: false,
					value: "Supply Stock/Equipment",
				},
				{ label: "Other", checked: false, value: "Other" },
			],
			// wasteType: [
			//   { label: "General Waste", checked: false, value: "General Waste" },
			//   { label: "Recycling", checked: false, value: "Recycling" },
			//   {
			//     label: "Furniture/Bulky Waste",
			//     checked: false,
			//     value: "Furniture/Bulky Waste",
			//   },
			//   {
			//     label: "Sharps",
			//     checked: false,
			//     value: "Sharps",
			//   },
			//   {
			//     label: "Waste Electricals",
			//     checked: false,
			//     value: "Waste Electricals",
			//   },
			//   { label: "Batteries", checked: false, value: "Batteries" },
			//   {
			//     label: "Stock/Consumable Order",
			//     checked: false,
			//     value: "Stock/Consumable Order",
			//   },
			//   { label: "Other", checked: false, value: "Other" },
			// ],
			OtherText: "",
			loading: false,
			otherbox: false,
			enabled: false,
			multiLine: true,
			svgPath: mdiClose,
			timeout: 0,
			userFeedback: false,
			emailSent: false,
			submitError: "",
			checkboxFeedback: "",
			Required: [(v) => !!v || "Required."],
			emailRules: [
				(v) => !!v || "E-mail is required",
				(v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
			],
			rules: {
				chooseOne: (selected) => selected.length > 0 || "Choose One",
			},
		};
	},
	methods: {
		capitalizeFirstLetter(string) {
			return string[0].toUpperCase() + string.slice(1);
		},
		addOther() {
			let found = this.form.selected.findIndex((item) => {
				return item === "Other";
			});

			if (found != -1) {
				this.form.selected[found] = "Other: " + this.OtherText;
			}
		},
		checkEnabled(wasteItem) {
			if (wasteItem === "Other") this.enabled = !this.enabled;
		},
		async submitForm() {
			this.submitError = "";
			this.addOther();

			if (
				!(
					(this.$refs.form2.validate() && this.form.confirm) ||
					this.formType === "other"
				)
			)
				return;

			if (this.pics.length > MAX_PICS) {
				this.submitError = `Please attach no more than ${MAX_PICS} pictures.`;
				return;
			}
			const totalBytes = this.pics.reduce((sum, pic) => sum + pic.size, 0);
			if (
				this.pics.some((pic) => pic.size > MAX_PIC_BYTES) ||
				totalBytes > MAX_TOTAL_PIC_BYTES
			) {
				this.submitError =
					"Pictures must be under 10MB each and 25MB in total.";
				return;
			}

			// Status, ID, dates and picture links are set by the server
			// eslint-disable-next-line no-unused-vars
			const { status, closeTech, picArray, ...fields } = this.form;
			const body = new FormData();
			body.append(
				"form",
				JSON.stringify({
					...fields,
					sites: this.form.sites ? this.form.sites.site : "",
				}),
			);
			this.pics.forEach((pic) => body.append("pics", pic, pic.name));

			this.loading = true;
			try {
				const { data } = await axios.post(SUBMIT_REQUEST_URL, body);
				this.requestId = data.requestId;
				this.emailSent = data.emailSent;
				this.userFeedback = true;
				this.createForm();
			} catch (err) {
				this.submitError =
					(err.response && err.response.data && err.response.data.error) ||
					"Your request could not be submitted. Please try again.";
			} finally {
				this.loading = false;
			}
		},
		setModal() {
			this.formDialog = true;
		},
		setForm(prop) {
			this.formType = prop;
			this.form.formType = prop;
			this.formDialog = false;
		},
		createForm() {
			((this.form = {
				formType: "",
				sites: "",
				building: "",
				department: "",
				floor: "",
				roomNum: "",
				locDesc: "",
				deptLocation: "",
				asstManager: "",
				budgetCode: "",
				fName: "",
				lName: "",
				altFName: "",
				altLName: "",
				phone: "",
				altPhone: "",
				email: "",
				status: "Open",
				altEmail: "",
				selected: [],
				containerNumber: "",
				requestDetails: "",
				picArray: [],
				warpIt: "",
				confirm: "",
				confWasteConsole: false,
				consoleQty: "",
				consoleList: "",
				confWasteBin: false,
				binQty: "",
				binList: "",
				confWasteBag: false,
				bagQty: "",
			}),
				(this.pics = []));
			this.OtherText = "";
			this.otherbox = false;
			this.enabled = false;

			this.$refs.form2.resetValidation();
		},
	},
};
</script>

<style>
h1 {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
h3.title {
	color: #00bfa5;
	text-decoration: underline;
	padding-left: 25px;
	padding-right: 25px;
}
h3.text {
	color: #00bfa5;
	font-weight: normal;
	padding-left: 25px;
	padding-right: 25px;
}
div.center {
	text-align: center;
	padding: 10px 10px;
}
div.desc {
	padding: 15px 25px;
}
</style>
